var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply-benefits-list"},[_c('Margins',[_c('h6',{staticClass:"text-normal"},[_c('span',{staticClass:"header-line"},[_vm._v(_vm._s(_vm.$t('ABOUT_FAIROWN')))])]),_vm._l((_vm.texts),function(text,key){return _c('p',{key:key,class:[
        'text-small text-grey',
        { ['margins__double']: key === 'TEXT_1' },
      ]},[_vm._v(" "+_vm._s(text)+" ")])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }